// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IIndexJson {
  files: string[];
  folders: string[];
}
